export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-7.png?ad21d422929659ba8d01d04a0516a2bc";